import { render, staticRenderFns } from "./ReplyIcon.vue?vue&type=template&id=d0ce864a&"
import script from "./ReplyIcon.vue?vue&type=script&lang=js&"
export * from "./ReplyIcon.vue?vue&type=script&lang=js&"
import style0 from "./ReplyIcon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports